import { PcApiResponse } from '@/api/pc-api/types';
import { MydataProduct } from '@/api/pc-api/v1/product/list/types';
import { api } from '@/utils/api';

export const getProductListMyData = (isTest?: boolean) => {
  return api<PcApiResponse<MydataProduct[]>>('get', `/pc-api/v1/product/list/mydata`, { isTest });
};
